import styled from "styled-components";
import { Grid } from "@material-ui/core";

const GridFullHeight: any = styled(Grid)`
  height: 100%;
`;

export default GridFullHeight;
